import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Snowflake01 = function Snowflake01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18.0622 8.5-12.1244 7m12.1244-7 1.098-4.098M18.0622 8.5l4.098 1.098M5.9378 15.5l-4.098-1.0981M5.9377 15.5l-1.098 4.0981m13.2223-4.0982-12.1244-7m12.1244 7 4.0981-1.0981m-4.0981 1.0981 1.0981 4.0981M5.9377 8.4999 4.84 4.402M5.9377 8.5 1.84 9.5982M12 5v14m0-14L9 2m3 3 3-3m-3 17-3 3m3-3 3 3"
    })
  }));
};
export default Snowflake01;